import { useParams } from "react-router";

export function useDossierId() {
    const { id } = useParams() as { id: string };
    return id;
}
